import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { PwaHandshakeService } from '../pwa-handshake.service';
import { AuthService } from '../transaction/auth.service';
import { ObservabilityService } from '../core/observability/observability.service';

export interface SessionDiagnostics {
  stage?: string;
  at?: string;
  status?: number | string;
  statusText?: string;
  url?: string;
  message?: string;
  debugCause?: string;
  isCorsOrNetwork?: boolean;
  isLocalhost?: boolean;
  backendCode?: string;
  backendMessage?: string;
  hasDiasporaSessionToken?: boolean;
  tokenPreview?: string | null;
  [key: string]: unknown;
}

@Component({
  selector: 'app-service-unavailable',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './service-unavailable.component.html',
  styleUrl: './service-unavailable.component.css'
})
export class ServiceUnavailableComponent implements OnInit {

  diagnostics: SessionDiagnostics | null = null;
  hasDiasporaSessionToken = false;
  tokenPreview: string | null = null;
  isLocalhost = false;
  isCorsBlocked = false;
  showRawDiagnostics = false;
  copied = false;

  constructor(
    private router: Router,
    private pwaHandshakeService: PwaHandshakeService,
    private authService: AuthService,
    private observabilityService: ObservabilityService
  ) {}

  ngOnInit(): void {
    this.isLocalhost =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

    this.checkTokenAndDiagnostics();
    this.observabilityService.warn('ServiceUnavailable', 'Service unavailable screen rendered', this.diagnostics);
  }

  checkTokenAndDiagnostics(): void {
    const rawToken = localStorage.getItem('token') || this.authService.diasporaSessionToken();
    if (rawToken && rawToken !== 'undefined' && rawToken !== 'null') {
      this.hasDiasporaSessionToken = true;
      this.tokenPreview = rawToken.length > 14 ? `${rawToken.slice(0, 10)}...` : rawToken;
    } else {
      this.hasDiasporaSessionToken = false;
      this.tokenPreview = null;
    }

    const rawDiag = localStorage.getItem('h5-session-diagnostics');
    if (rawDiag) {
      try {
        this.diagnostics = JSON.parse(rawDiag);
        if (this.diagnostics?.status === 0 || this.diagnostics?.isCorsOrNetwork) {
          this.isCorsBlocked = true;
        }
      } catch (e) {
        console.error('Failed to parse diagnostics from localStorage', e);
      }
    }
  }

  proceedWithDevToken(): void {
    const devToken = 'dev-token-' + crypto.randomUUID().slice(0, 8);
    const correlationId = localStorage.getItem('correlation-id') || crypto.randomUUID();

    localStorage.setItem('token', devToken);
    localStorage.setItem('superapp-token', 'dev-superapp-token');
    localStorage.setItem('correlation-id', correlationId);

    this.authService.setDiasporaSessionToken(devToken);
    this.authService.setUUID(correlationId);

    this.router.navigateByUrl('/amount');
  }

  launchWithUatToken(): void {
    const token = '256779999613-1789084800000-1793404800000-p0mqvn-1nkyqa9';
    const correlationId = '540e5e2f-2f0f-496e-8898-bab183afec52';
    window.location.href = `/?mobileAccessToken=${token}&correlationId=${correlationId}`;
  }

  toggleDiagnostics(): void {
    this.showRawDiagnostics = !this.showRawDiagnostics;
  }

  copyDiagnostics(): void {
    const fullDiagnostics = this.observabilityService.exportDiagnostics();
    navigator.clipboard?.writeText(JSON.stringify(fullDiagnostics, null, 2));
    this.copied = true;
    setTimeout(() => (this.copied = false), 2500);
  }

  close(): void {
    this.pwaHandshakeService.done();
    this.router.navigate(['/']);
  }
}

